module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAUCAYAAAB4d5a9AAAACXBIWXMAAAsSAAALEgHS3X78AAABFElEQVQ4jb2V0VGEMBBAHxny7ZVABSYdeJcG1A6wA0qhA88OtIEMJdx2cCVw3/nAD2Dk1CAScf+SzczL7L5ssq7r0MYVQMG6aIP409yBLL89WKABblZCAJ6C+GMsqYB9IgCgmktmQ7lqwK4EtEAZxLezkK1DbU74L0gOoI3bkdCTJQrv6BU2KyEAj0H8ayypgDIRAD8orIL4GnhJAFzoLxqNTRTWxpXA87A8/Lld2jgL1NO9JIg2rhjMnAIaPsbUBTjnCYCxzgLYCGAfxJ9/q7AE8fYTBOCN60E7Ak7Ql6taCAAw2rhR16mR91xP8mr6QBV9k2QhRIAjQBBf8r36X/6WZIW1cQ1wFwPAMLsS4wFg7j95B4hkZNzrHKC6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager/tasks_icon_rep_audit_trail.png
// module id = bQEJ
// module chunks = 0